import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const HUNGARY_DATABASE_COUNTRY_ID = 17;

export const HungaryCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.HUNGARY,
  languageCode: ELanguageCode.HUNGARIAN,
  country: ECountry.HUNGARY,
  phoneAllowed: true,
  addressAllowed: true,
  phone: {
    mask: "+36 99999999?9",
    placeholder: "+36 (9)9 999 9999",
    prefix: "+36",
  },
  databaseCountryId: HUNGARY_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
